import { CoreTypography, CoreTypographyVariant } from '@ingenico/react-ui/core-typography';
import InfoIcon from '@mui/icons-material/InfoOutlined';
import { Tooltip } from '@mui/material';

import type { ReactNode } from 'react';
import { memo } from 'react';
import styles from './LogicalDeviceLocationCardSubtitle.module.scss';

export interface LogicalDeviceLocationCardSubtitleProps {
  readonly label: string;
  readonly value?: string;
  readonly tooltip?: string;
}

function LogicalDeviceLocationCardSubtitleCpt({
  label,
  tooltip,
  value,
}: LogicalDeviceLocationCardSubtitleProps): ReactNode {
  return (
    <div className={styles.container}>
      <div className={styles.labelValueContainer}>
        <CoreTypography customClassName={styles.label} variant={CoreTypographyVariant.Body02Regular}>
          {label}
        </CoreTypography>
        {value ? (
          <CoreTypography customClassName={styles.value} variant={CoreTypographyVariant.Body02Regular}>
            {value}
          </CoreTypography>
        ) : undefined}
      </div>
      {tooltip ? (
        <Tooltip title={tooltip}>
          <InfoIcon className={styles.tooltipIcon} />
        </Tooltip>
      ) : undefined}
    </div>
  );
}

export const LogicalDeviceLocationCardSubtitle = memo(LogicalDeviceLocationCardSubtitleCpt);
